function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["anchor", "frame", "offset", "orient", "angle", "limit", "color", "subtitleColor", "subtitleFont", "subtitleFontSize", "subtitleFontStyle", "subtitleFontWeight", "subtitleLineHeight", "subtitlePadding"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { isArray, isString } from 'vega-util';
import { pick } from './util';
export function extractTitleConfig(titleConfig) {
  var anchor = titleConfig.anchor,
    frame = titleConfig.frame,
    offset = titleConfig.offset,
    orient = titleConfig.orient,
    angle = titleConfig.angle,
    limit = titleConfig.limit,
    color = titleConfig.color,
    subtitleColor = titleConfig.subtitleColor,
    subtitleFont = titleConfig.subtitleFont,
    subtitleFontSize = titleConfig.subtitleFontSize,
    subtitleFontStyle = titleConfig.subtitleFontStyle,
    subtitleFontWeight = titleConfig.subtitleFontWeight,
    subtitleLineHeight = titleConfig.subtitleLineHeight,
    subtitlePadding = titleConfig.subtitlePadding,
    rest = _objectWithoutProperties(titleConfig, _excluded);
  var titleMarkConfig = _objectSpread(_objectSpread({}, rest), color ? {
    fill: color
  } : {});
  // These are non-mark title config that need to be hardcoded
  var nonMarkTitleProperties = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, anchor ? {
    anchor: anchor
  } : {}), frame ? {
    frame: frame
  } : {}), offset ? {
    offset: offset
  } : {}), orient ? {
    orient: orient
  } : {}), angle !== undefined ? {
    angle: angle
  } : {}), limit !== undefined ? {
    limit: limit
  } : {});
  // subtitle part can stay in config.title since header titles do not use subtitle
  var subtitle = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, subtitleColor ? {
    subtitleColor: subtitleColor
  } : {}), subtitleFont ? {
    subtitleFont: subtitleFont
  } : {}), subtitleFontSize ? {
    subtitleFontSize: subtitleFontSize
  } : {}), subtitleFontStyle ? {
    subtitleFontStyle: subtitleFontStyle
  } : {}), subtitleFontWeight ? {
    subtitleFontWeight: subtitleFontWeight
  } : {}), subtitleLineHeight ? {
    subtitleLineHeight: subtitleLineHeight
  } : {}), subtitlePadding ? {
    subtitlePadding: subtitlePadding
  } : {});
  var subtitleMarkConfig = pick(titleConfig, ['align', 'baseline', 'dx', 'dy', 'limit']);
  return {
    titleMarkConfig: titleMarkConfig,
    subtitleMarkConfig: subtitleMarkConfig,
    nonMarkTitleProperties: nonMarkTitleProperties,
    subtitle: subtitle
  };
}
export function isText(v) {
  return isString(v) || isArray(v) && isString(v[0]);
}